import React, { Component } from 'react';
import { getOrders } from '../services/orderService';
import { getUsers } from '../services/userService';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Loader from './loader';

class Customers extends Component {
  state = {
    orders: [],
    users: [],
    loading: true
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.props.updateDashboardMenu('customers');

    const { data: users } = await getUsers();
    this.setState({ users });

    const { data: orders } = await getOrders();
    this.setState({ orders, loading: false });
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    const { users, loading } = this.state;

    if (loading) return <Loader />;


    return (
      <div className='customers-page'>
        <div className='row'>
          <div className='col-md-12 p-2'>
            <div
              className='profile-right-block'
              style={{ animationDelay: '0.1s' }}
            >
              <h1>Customers</h1>
              <br />
              <table className=' orders-table'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th className='hide-col'>Joined</th>
                    <th className='hide-col'>Email</th>
                    <th className='hide-col'>Orders</th>
                    <th>Information</th>
                  </tr>
                </thead>

                <tbody>
                  {users.filter(u => !u.isAdmin)
                    .reverse()
                    .map((o) => (
                      <tr key={o._id}>
                        <td>
                          <div className='cutomer'>
                            <div
                              className='customer-pic'
                              style={{
                                width: '50px',
                                height: '50px',
                                marginRight: '10px',
                                backgroundImage: 'url(' + o.profilePic + ')',
                              }}
                            ></div>
                            {o.name}
                          </div>
                        </td>
                        <td className='hide-col purchased-col'>
                          {moment(o.publishDate).fromNow()}
                        </td>
                        <td className='hide-col'>
                          <a href={'mailto:' + o.email}>{o.email}</a>
                        </td>
                        <td className='hide-col'>{this.totalOrders(o._id)}</td>
                        <td>
                          <Link to={`/dashboard/customers/customer/${o._id}`}>
                            <button className='view-order'>View</button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }

  totalOrders = (id) => {
    const { orders } = this.state;
    const order = orders.filter((u) => u.userId === id);

    return order.length;
  };
}

export default Customers;
